import React, { useEffect, useState, createContext, useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Partners } from "./pages/Partners";
import { Contact } from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Login from "./pages/login";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

// ✅ Auth context types
interface AuthContextType {
  isAuthenticated: boolean;
  setIsAuthenticated: (authState: boolean) => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);

// ✅ Route protection
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const context = useContext(AuthContext);
  if (!context) return <Navigate to="/login" replace />;
  const { isAuthenticated } = context;
  const isUserAuthenticated = isAuthenticated || localStorage.getItem("isAuthenticated") === "true";
  return isUserAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    localStorage.getItem("isAuthenticated") === "true"
  );

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const authState = !!user || localStorage.getItem("isAuthenticated") === "true";
      setIsAuthenticated(authState);

      if (authState) {
        localStorage.setItem("isAuthenticated", "true");
      } else {
        localStorage.removeItem("isAuthenticated");
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      <Router>
        <div className="flex flex-col min-h-screen bg-gradient-to-b from-gray-50 to-white">
          {isAuthenticated && <Navigation />}
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              {/* <Route path="/partners" element={<ProtectedRoute><Partners /></ProtectedRoute>} /> */}
              {/* <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} /> */}
              <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
              {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
              {/* <Route path="/terms" element={<Terms />} /> */}
            </Routes>
          </main>
          {isAuthenticated && <Footer />}
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
